import { get, filter, map, pipe, without } from 'lodash/fp';
import type { Column } from 'app/lib/types/server';
import { AggregationType } from 'app/lib/constants';

export const unspecificAggregates = [
    AggregationType.COUNT,
    AggregationType.COUNT_DISTINCT,
    AggregationType.APPROX_COUNT_DISTINCT,
    AggregationType.MODE,
    AggregationType.ANY,
    AggregationType.MIN,
    AggregationType.MAX
].sort();

export const numericAggregates = [
    AggregationType.MEDIAN,
    AggregationType.SKEW,
    AggregationType.KURTOSIS,
    AggregationType.SUM,
    AggregationType.AVG,
    AggregationType.STDDEV,
    AggregationType.STDDEV_POP,
    AggregationType.VAR_POP,
    AggregationType.VAR_SAMP
]
    .concat(unspecificAggregates)
    .sort();

export const functionsForType = (type: string) => {
    switch (type) {
        case 'STRING':
        case 'VARCHAR':
        case 'BOOLEAN':
        case 'DATE':
        case 'TIME':
        case 'TIMESTAMP':
            return unspecificAggregates;

        default:
            return numericAggregates;
    }
};

const NON_NUMERIC_TYPES = ['STRING', 'VARCHAR', 'BOOLEAN', 'DATE', 'TIME', 'TIMESTAMP'];

export const isNumericType = (type: string) => !NON_NUMERIC_TYPES.includes(type);

const getAggregations = map(get('aggregation'));

type Measures = {
    name: string;
    aggregation: AggregationType;
}[];
export const availableAggregations = (column: Column, measures: Measures): AggregationType[] => {
    const allFunctions = functionsForType(column?.typeFamily);
    const existing = pipe(filter({ name: column?.name }), getAggregations)(measures);

    return without(existing, allFunctions);
};
